<template>
  <div>
    <CStepper :steps="steps" />
    <CMessage :messages="message.base" />
    
    <div v-if="steps.current==0">
      <CInputPassword
        v-model="user.current_password"
        label="user.current_password"
        :errors="message.current_password"
      />
      <CButton
        label="confirm"
        @click.prevent="confirm_current_password()"
      />
    </div>

    <div v-if="steps.current==1">
      <div class="card-a bg-warning">
        {{ $t('views.help.otp.generate') }}
      </div>
      <CInputText
        v-model="user.otp"
        label="user.otp"
        :errors="message.otp"
      />
      <CButton
        label="confirm"
        @click.prevent="confirm_otp()"
      />
      <CLink
        label="generate_otp"
        @click.prevent="generate_otp()"
      />
      <CMessage
        :messages="message.success"
        type="success"
      />
    </div>

    <div v-if="steps.current==2">
      <CInputPassword
        v-model="user.password"
        label="user.new_password"
        :errors="message.password"
      />
      <CInputPassword
        v-model="password_repeat"
        label="user.new_password_repeat"
      />
      <CButton
        label="change"
        @click.prevent="change()"
      />
    </div>
  </div>
</template>

<script>
import ApiRequestor from '../common/ApiRequestor'

export default {
  name: "ChangePassword",
  data: function () {
    return {
      message: {},
      user: {
        current_password: '',
        password: '',
        reset_password_token: '',
        otp: ''
      },
      password_repeat: '',
      steps: {
        names: ['change_password.current_password', 'change_password.otp_confirm', 'change_password.new_password'],
        current: 0
      }
    }
  },
  computed: {
    isLoggedIn() {
      return this.$store.state.auth.isLoggedIn;
    },
    otpParams() {
      return {
        otp: this.user.otp
      }
    }
  },
  methods: {
    confirm_current_password() {
      ApiRequestor.post('current_user/password/confirm_current_password', {user: { current_password: this.user.current_password }}).then(
        response => {
          this.message = {}
          this.steps.current ++;
        },
        error => {
          this.message = error.response.data
        }
      );
    },
    confirm_otp() {
      ApiRequestor.post('current_user/password/confirm_otp', {user: { otp: this.user.otp }}).then(
        response => {
          this.user.reset_password_token = response.data.reset_password_token;
          this.message = {}
          this.steps.current ++;
        },
        error => {
          this.message = error.response.data
        }
      );
    },
    generate_otp() {
      ApiRequestor.post('users/otp', {user: this.otpParams}).then(
        response => {
          this.message = { success: this.$t('views.success.generate_otp') }
        },
        error => {
          this.message = error.response.data
        }
      );
    },
    change() {
      if(this.user.password != this.password_repeat) {
        this.message = { password_repeat: [this.$t('views.failure.password_not_matching')] }
        return
      }
      ApiRequestor.put('current_user/password', {user: this.user}).then(
        response => {
          this.$store.dispatch("auth/login", response.data.jwt);
          this.$router.push({ name: 'home' });
        },
        error => {
          this.message = error.response.data
        }
      );
    }
  }
}
</script>